module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e1715551"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c5_r1#d6e3",
      "id": "d7e3"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#f2ac0c"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#d15d22"
    }
  }, [_vm._v("SOUPS, STEWS & ONE-POT MEALS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1716851"
    }
  }, [_vm._v("Whether made on the stovetop or in a slow cooker, soups, stews, and chilis are the very essence of one-pot cooking, and, as you would expect, have a lot in common. They are all made in one pot, they taste even better a day or so later, and they are as easy to cook up in small amounts as in large potfuls, especially if you utilize a slow cooker! Even better, they make almost a complete meal. Begin with a crisp green salad, add some fresh bread, and dinner is served. How easy is that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1721051"
    }
  }, [_vm._v("In this chapter, you will find recipes from all corners of the globe, including Vietnamese Noodle Soup, Gazpacho with Cilantro Cream, Moroccan Vegetable Stew, Hungarian Pork Goulash, Provençal Beef Stew, and Pasta e Fagiole with Sausage. "), _c('b', [_vm._v("Slow-cooker specialties, from Tomatillo Pork to Sweet and Tangy Braised Chuck Roast, are all indicated with the following symbol:")]), _c('img', {
    staticStyle: {
      "margin-bottom": "-0.2em",
      "max-width": "100%"
    },
    attrs: {
      "alt": "2",
      "src": "Images/2.jpg"
    }
  }), _vm._v(". "), _c('b', [_vm._v("To achieve one-pot perfection, see 10 Helpful Tips for the Slow Cooker.")])]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e1726451"
    }
  }, [_c('b', [_vm._v("SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1726951"
    }
  }, [_vm._v("Soups are infinite in variety and exceptionally versatile. A soup can be a light and elegant first course, a substantial rib-sticking meal-in-a-pot, or a refreshing cooler on a summer’s day. It can be a crystal-clear golden liquid, a silky smooth and creamy puree, or thick with vegetables, noodles, and a protein, such as chicken or beef. Some soups are always served cold, like gazpacho, and some are always served hot, such as split pea soup. And others are so versatile that they are just as delicious hot, cold, or at room temperature. Whatever your preference, there is a soup to suit your taste.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e1731351"
    }
  }, [_c('b', [_vm._v("STEW")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1732151"
    }
  }, [_vm._v("Warming, hearty, and always satisfying, stews are perfect cold-weather food. Stews can be made with chicken, pork, beef, veal, or fish that has been cut into small pieces or hearty chunks. And while some stews are laden with a variety of vegetables, others contain only one or two. The liquid can be as varied as the ingredients themselves: water, broth, tomato juice, and wine, or a combination can all work in a stew. Served up in large shallow bowls with hunks of bread for sopping up all the flavorful juices, a stew is comfort food of the first order.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e1736651"
    }
  }, [_c('b', [_vm._v("CHILI")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1737151"
    }
  }, [_vm._v("Just who cooked up the first chili is in dispute, but many chili aficionados believe credit must go to the Texas trail cooks who fed the cowboys while “winning the West.” In fact, by 1880 eating a “bowl of red” was commonplace in cities like San Antonio. In this chapter we offer a tasty variety of all-American chilis. Some are made with chunks of beef, others with ground beef, and one is made with tasty pieces of pork. Our Cincinnati Chili gets served up on a bed of spaghetti, while the New Mexican Green Chili is a bold pot of pork shoulder chunks, onions, jalapeños, cumin, cayenne, fresh tomatillos, and poblanos that speaks of the best of the Southwest.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0078e860","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c45_r1.vue
// module id = 201
// module chunks = 0